import camelcaseKeys from 'camelcase-keys';
import { z } from 'zod';

const UpdateCustomerSettingsBodySchema = z
  .object({
    name: z.string().optional(),
    website_url: z.string().nullable().optional(),
    country: z.string().optional(),
    business_type: z.string().optional(),
    managed_location_range: z.string().optional()
  })
  .transform((data) => camelcaseKeys(data));

/**
 * Response schema for update customer endpoint.
 * API may return the updated customer object or null.
 */
export const UpdateCustomerSettingsSchema = UpdateCustomerSettingsBodySchema.nullable();

/** Request params for updating customer settings */
export type UpdateCustomerSettings = NonNullable<z.infer<typeof UpdateCustomerSettingsSchema>>;
